

class SequenceLink {
  constructor(opening, closing) {
    this.closing = closing
    this.opening = opening
    this.option = null
  }
}

export default SequenceLink